import { useState } from 'react'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { resetPassword as resetPasswordApi } from '../../api/auth'
import PasswordField from '../../components/PasswordField'
import AuthPage, { AuthField } from '../../components/PublicLayout'

export default function ResetPassword() {
  const nav = useNavigate()
  const { token: tokenFromPath = '' } = useParams()
  const [searchParams] = useSearchParams()
  const token = String(tokenFromPath || searchParams.get('token') || '').trim()
  // A new person's first password (a practice added them, or their company).
  const welcome = searchParams.get('welcome') === '1'

  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const [done, setDone] = useState(false)

  const submit = async (e) => {
    e && e.preventDefault()
    if (!token) { setErr('This link isn’t complete. Ask for a new one.'); return }
    if (!newPassword || newPassword.length < 8) {
      setErr('Use a password of at least 8 characters.')
      return
    }
    if (newPassword !== confirmPassword) {
      setErr('The two passwords don’t match.')
      return
    }

    setBusy(true)
    setErr('')
    try {
      await resetPasswordApi(token, newPassword)
      setDone(true)
      setTimeout(() => nav('/login'), 1200)
    } catch (e) {
      setDone(false)
      setErr(String(e?.response?.data?.message || e?.response?.data?.error || e?.message || e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthPage
      title={welcome ? 'Choose your password' : 'Choose a new password'}
      intro={welcome ? 'Then sign in with the Company ID and username in your email.' : 'Then sign in with it.'}
      top={<Link className="pub-btn pub-btn-ghost" to="/login">Sign in</Link>}
      foot={<>Link not working? <Link to="/forgot-password">Ask for a new one</Link></>}
    >
      {!token && <p className="pub-error" role="alert">This reset link isn’t complete. Ask for a new one below.</p>}
      <form onSubmit={submit} className="pub-form" noValidate>
        <AuthField id="reset-new-password" label={welcome ? 'Password' : 'New password'} hint="At least 8 characters.">
          <PasswordField id="reset-new-password" value={newPassword} onChange={(e) => { setNewPassword(e.target.value); setDone(false) }} autoFocus autoComplete="new-password" />
        </AuthField>
        <AuthField id="reset-confirm-password" label={welcome ? 'Password again' : 'New password again'}>
          <PasswordField id="reset-confirm-password" value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value); setDone(false) }} autoComplete="new-password" />
        </AuthField>
        {err && <p className="pub-error" role="alert">{err}</p>}
        {done && !err && <p className="pub-notice pub-notice-good" role="status">Password changed. Taking you to sign in…</p>}
        <button type="submit" className="pub-btn pub-btn-primary pub-btn-block" disabled={busy || !token}>{busy ? 'Saving…' : (welcome ? 'Save my password' : 'Save the new password')}</button>
      </form>
    </AuthPage>
  )
}
